import React from "react";
import { CLOSE_ICON } from "../../../utills/image-constant";

const Modal = ({
  modalBody,
  buttonLable = "",
  modalClick,
  modalClose,
  modalimg = "",
  title = "",
  msg = "",
  onAddItem = '',
  children,
  heading = "",
  className = '',
  handleClick = function o() { },
}) => {
  return (

    <div className="emp-model">
      <button
        type="button"
        class="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop"
        ref={modalClick}

      >
      </button>

      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className={`modal-dialog modal-dialog-centered ${className}`}>
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="btn btnclose"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src={CLOSE_ICON} alt="close"></img>
              </button>
              <h5 class="modal-title" id="staticBackdropLabel">
                {title}
              </h5>
            </div>
            <div class="modal-body">
              <h5 className="tableheading">{heading}</h5>
              {children}
            </div>
            <div class="modal-footer">
              {buttonLable && (<button type="button" class="btn btn-primary" onClick={onAddItem}>
                {buttonLable}
              </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
